module.exports = __webpack_public_path__ + "img/ckTip.9210f515.png";